module.exports = __webpack_public_path__ + "img/tdIcon.27f90bf8.png";